import { useMemo } from "react";
import { useSelector } from "react-redux";
import { DateTimeFormatStyle, useI18nContext } from "@hopper-b2b/i18n";
import { useControlledDialog } from "@tenant/ui";
import dayjs from "dayjs";
import { CarsAvailabilitySelectors } from "~core-cars/store";

export const useCarAvailabilitySearch = () => {
  const search = useSelector(CarsAvailabilitySelectors.getSearch);
  const { t, formatDateTime } = useI18nContext();

  const dialogProps = useControlledDialog();

  const handlers = useMemo(
    () => ({
      handlers: {
        onSearch: () => {
          dialogProps.closeDialog();
        },
      },
    }),
    [dialogProps]
  );

  return useMemo(() => {
    if (!search) {
      return {
        context: {
          search: null,
          dialogProps,
        },
        ...handlers,
      };
    }

    const { pickupTime, dropoffTime, pickupLocation } = search;

    const formatOptions = DateTimeFormatStyle.Custom({
      month: "short",
      day: "numeric",
    });

    const pickUpDate = formatDateTime(new Date(pickupTime), formatOptions);
    const dropOffDate = formatDateTime(new Date(dropoffTime), formatOptions);

    return {
      context: {
        search: {
          location: pickupLocation.label,
          summary: t("core-cars.availability.searchSummary.dates", {
            startDate: pickUpDate,
            endDate: dropOffDate,
          }),
        },
        dialogProps,
      },
      ...handlers,
    };
  }, [dialogProps, formatDateTime, handlers, search, t]);
};
